import React, {useContext, useEffect, useState} from 'react'
import {RecipeConText} from "../../../../../context/RecipeContext";


const RecipeProductionMidTotal = () => {
    const {prodCostsTotal, productionMidTotal} = useContext(RecipeConText)
    const [total, setTotal] = useState(0)

    useEffect(() => {
        setTotal(prodCostsTotal + productionMidTotal)
    }, [prodCostsTotal, productionMidTotal])

    return (
        <React.Fragment>
            <div style={{textAlign: "right"}}>
                <h6>Ürün Maliyeti:</h6>
                {
                    <p><span>{new Intl.NumberFormat().format(total)} USD</span></p>

                }
            </div>
        </React.Fragment>
    )
}
export default RecipeProductionMidTotal